<h1 mat-dialog-title>Carga de archivo (xlsx)</h1>

<div mat-dialog-content>
    <input class="form-control-sm form-control input-full-width"
           type="file"
           (change)="uploadFile($event)">

    @if (jsonDataLength) {
        <span>Total de renglones en archivo: <b>{{ jsonDataLength | number }}</b></span>
    }
</div>

<div mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Cerrar</button>
    <button mat-raised-button color="primary"
            [disabled]="!jsonData.length"
            (click)="getJsonData()">Cargar archivo</button>
</div>